import type { NowExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const nowResolver = createSimpleNamedExpressionResolver<NowExpression>(
  'now',
  Date.now
);
